module.exports = __webpack_public_path__ + "static/media/yunjiadajianshan_plant.b918b484.webp";